// extracted by mini-css-extract-plugin
export default {"form":"Form_form__4vlSK","header":"Form_header__3bmVv"};